import * as ng from 'angular';

class FatturazionePRController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'store'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private store: ng.a0.storage.IStoreService
    ) {
        $scope.user = store.get('user');
        $rootScope.accepted = false;
        $scope.pageHeader = 'Fatturazione Privati';
        $scope.tooltips = {
            'create': 'Crea la tua fattura elettronica e trasmettila allo Sdi in pochi facili passi.',
            'upload': 'Carica il file XML di una fattura elettronica creata con strumenti,\nsoftware o servizi diversi da ArchiSMALL e trasmettilo allo Sdi.',
            'check': 'Consulta le tue fatture inviate e visualizza le relative notifiche.\nSe hai dei dubbi sugli stati della fattura segui i consigli di ArchiSMALL.',
            'receive': 'Da questa sezione potrai ricevere e gestire le fatture elettroniche passive inviate dai tuoi fornitori.\n' +
                'Per ricevere le fatture elettroniche inviate dai tuoi fornitori su ArchiSMALL devi aver preso visione e accettato,\nal primo accesso, il Codice Destinatario (7 caratteri alfanumerici) fornito dall\'Agenzia delle Entrate.\n' +
                'Verifica che i tuoi fornitori siano a conoscenza del tuo Codice Destinatario esatto e che lo indichino nell\'xml o\nnon riceverai le loro fatture elettroniche.'
        };
    }

}

export const FatturazionePRComponent: ng.IComponentOptions = {
    template: require('./fatturazione-pr.html'),
    controller: FatturazionePRController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/fatturazione-pr.ts